import { render, staticRenderFns } from "./CardRulePage.vue?vue&type=template&id=164a5950&scoped=true"
import script from "./CardRulePage.vue?vue&type=script&lang=js"
export * from "./CardRulePage.vue?vue&type=script&lang=js"
import style0 from "./CardRulePage.vue?vue&type=style&index=0&id=164a5950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a5950",
  null
  
)

export default component.exports